import React from 'react'
import { useState, useEffect } from 'react'
import { Drawer, Form, Row, Col ,Button, Space } from "antd"
import { MyInput, MySelect } from '../../Forms';
import { checkAuthorization, domainUrl } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';

const PaymentMethodDrawer = ({visible, onClose, edititem}) => {

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    // useEffect(() => {
    //     if (visible && edititem) {
    //         EditBlogCategory(edititem);
    //     } else {
    //         form.resetFields();
    //     }
    // }, [visible, edititem]);

    // const updateCreateApi = async (formData) => {
    //     setLoading(true);
    //     try {
    //         const result = await apiCalls.addBlogCategoryApi.updateCreateApi({...formData,id:edititem});
    //         setLoading(false);
    //         getAddBlogCategoryDetail();
    //         if (result) {
    //             form.resetFields();
    //             onClose();
    //         }
    //     } catch (error) {
    //         console.error('Error updating/creating blog category:', error);
    //         setLoading(false);
    //     }
    // };

    // const onFinish = async () => {
    //     try {
    //         const formData = await form.validateFields();
    //         updateCreateApi(formData);
    //     } catch (error) {
    //         console.error("Form validation error:", error);
    //     }
    // };

    // const EditBlogCategory = (id) => {
    //     const { userToken } = checkAuthorization();
    //     var myHeaders = new Headers();
    //     myHeaders.append("Content-Type", "application/json");
    //     myHeaders.append('Authorization', userToken);
    //     var requestOptions = {
    //         method: 'GET',
    //         headers: myHeaders,
    //         redirect: 'follow'
    //     };
    //     fetch(domainUrl + `/editBlogCategory/${id}`, requestOptions)
    //         .then(response => response.json())
    //         .then(result => {
    //             if (result?.success) {
    //                 result = result.data;
    //                 form.setFieldsValue({
    //                     ...result,
    //                     title: result?.title,
    //                 });
    //             } 
    //         })
    //         .catch(error => {
    //             alert(error.message);
    //         });
    // };

    const closeDrawer = () => {
        form.resetFields(); 
        onClose();
    };

    const skills = [
        { id: '1', name: 'Stripe' },
        { id: '2', name: 'Paypal' },
    ];

  return (
    <Drawer
        title={edititem?'Edit Payment Method':'Add Payment Method'}
        onClose={closeDrawer}
        className="drawer"
        open={visible}
        width={500}
        footer={
        <Space className="w-100 right">
            <Button 
                onClick={closeDrawer}
                className="btncancel"
            >
                Cancel
            </Button>
            <Button  
                block
                className='btnsave bg-brand'
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={()=> form.submit()}
            >
                {edititem? 'Update' : 'Save'}
            </Button>
        </Space>
    }
>
    <Form
        form={form}
        layout="vertical"
        initialValues={true}
        // onFinish={onFinish}
    >
        <Row gutter={16} justify={'center'}>
                    <Col span={24}>
                        <MyInput
                            name="cardName"
                            label="Card Name"
                            placeholder="Enter Card Name"
                            size='large'
                            value={form.getFieldValue("cardName") || ''}
                        />
                    </Col>
                    <Col span={24}>
                        <MyInput
                            name="cardNumber"
                            label="Card Number"
                            placeholder="Enter Card Number"
                            size='large'
                            value={form.getFieldValue("cardNumber") || ''}
                        />
                    </Col>
                    <Col span={24}>
                        <MySelect
                            label="Payment Method"
                            name="paymentMethod"
                            size="large"
                            message="Please enter skills/services"
                            options={skills}
                        />
                    </Col>
                    <Col span={24}>
                        <MyInput
                            name="cvc"
                            label="CVC"
                            placeholder="cvc"
                            size='large'
                            value={form.getFieldValue("cvc") || ''}
                        />
                    </Col>
                    <Col span={24}>
                        <MyInput
                            name="amount"
                            label="Amount"
                            placeholder="Amount"
                            size='large'
                            value={form.getFieldValue("amount") || ''}
                        />
                    </Col>
                    <Col span={24}>
                        <MyInput
                            name="expYear"
                            label="Expiry Year"
                            placeholder="1110-1111-9878"
                            size='large'
                            type='date'
                            value={form.getFieldValue("expYear") || ''}
                        />
                    </Col>
                    <Col span={24}>
                        <MyInput
                            name="expMonth"
                            label="Expiry Month"
                            placeholder="1110-1111-9878"
                            size='large'
                            type='date'
                            value={form.getFieldValue("expMonth") || ''}
                        />
                    </Col>
                </Row>
    </Form>
</Drawer>
  )
}

export {PaymentMethodDrawer}